<template>
  <div>
    <div class="modal" :class="{'modal--active': active}">
      <button class="modal__button" @click="close"><i class="fas fa-times"></i></button>
      <slot :data="data" ></slot>
    </div>
    <div class="modal-bg" :class="{'modal-bg--active': active}" @click="close"></div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  data() {
    return {
      active: false,
      data: null
    }
  },
  methods: {
    open(data) {
      this.activate(data)
    },
    activate(data) {
      this.active = true
      this.data = data
    },
    close() {
      this.active = false
    }
  }
}
</script>

<style lang="scss">
.modal {
  position: fixed;
  box-sizing: border-box;
  top: 45%; left: 50%;
  transform: translate(-50%, -100vh);
  padding: 24px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 2px 2px 8px -1px #ccc;
  z-index: 1100;
  visibility: hidden;
  opacity: 0;
  transition: 0.3s;
  backface-visibility: hidden;
  width: 95vw;

  @media screen and (min-width: #{$media-900}) {
    width: 800px;
  }

  &--active {
    transform: translate(-50%, -50%);
    visibility: visible;
    opacity: 1;
  }

  &__button {
    all: unset;
    position: absolute;
    top: 4px;
    right: 4px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #888;
    transition: color 0.3s;
    cursor: pointer;

    &:hover {
      color: firebrick;
    }
  }

  .delete-confirm {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    small {
      color: $primaryColor;
    }
  }
}

.modal-bg {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: rgba(#333, 0.6);
  z-index: 1000;
  visibility: hidden;
  opacity: 0;
  transition: 0.3s;

  &--active {
    visibility: visible;
    opacity: 1;
  }
}
</style>
